import classnames from 'classnames/bind'
import { ReactNode } from 'react'
import { GlobalTextPreset } from '~/@types/text-preset'
import { GlobalTextStyling } from '~/@types/text-styling'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

interface Switcher {
  onClick: (index: number) => void
  children: ReactNode | ReactNode[]
}

export interface SwitcherProps {
  className?: string
  switcherItemClassName?: string
  currentIndex?: number
  switchers?: Switcher[]
}

interface SwitcherItemProps {
  className?: string
  index?: number
  onClick?: (index: number) => void
  isActive?: boolean
  children?: ReactNode
}

function SwitcherItem({
  className,
  index,
  isActive,
  onClick,
  children,
}: SwitcherItemProps) {
  return (
    <button
      className={cx(className, css.switcher, { isActive })}
      onClick={(e) => {
        e.preventDefault()
        !isActive ? onClick(index) : null
        return false
      }}>
      {children}
    </button>
  )
}

function Switcher({
  className,
  currentIndex,
  switchers,
  switcherItemClassName,
}: SwitcherProps) {
  const textStyle = useStyle({
    textPreset: GlobalTextPreset.Cta12Primary,
    textStyling: GlobalTextStyling.UpperCase,
  })
  return (
    <div className={cx(css.Switcher, className)}>
      {switchers?.map((switcher, index) => (
        <SwitcherItem
          className={cx(switcherItemClassName, textStyle)}
          key={index}
          isActive={currentIndex === index}
          index={index}
          {...switcher}
        />
      ))}
    </div>
  )
}

Switcher.defaultProps = {}

export default Switcher
